<div class="flex min-w-0 flex-auto flex-col">
  <!-- Main Content -->
  <div class="flex-auto p-6 sm:p-10">
    <app-breadcrumb></app-breadcrumb>
    <!-- Table Title and Actions -->
    <div
      class=" rounded-2xl "
    >
      <div class="text-4xl font-extrabold tracking-tight flex m-5">
        <h1 class="text-4xl font-extrabold tracking-tight">Roles</h1>
        <mat-form-field class="w-3/12 ml-4">
          <input
            matInput
            placeholder="Search"
            [formControl]="searchForm.get('search')"
            (keyup)="onSearch($event)"
          />
          <button mat-icon-button matSuffix aria-label="Search">
            <mat-icon>search</mat-icon>
          </button>
        </mat-form-field>
        <button
          [disabled]="!hasDetailedPerm('Role_Management', 'Create', 'read')"
          class="ms-auto app-button"
          mat-flat-button
          (click)="createRole()"
        >
          <mat-icon [svgIcon]="'heroicons_outline:plus'"></mat-icon>
          <span class="ml-2 mr-1">Create Role</span>
        </button>
      </div>

      <!-- Material Table -->
      <div class="mat-elevation-z8 mx-5 bg-white  h-[calc(100vh-350px)] overflow-auto">
        <table mat-table [dataSource]="dataSource" matSort (matSortChange)="onSortChange($event)" class="">
          <ng-container matColumnDef="serial">
            <th mat-header-cell *matHeaderCellDef class="text-center">
              Sr. No.
            </th>
            <td
              mat-cell
              *matCellDef="let role; let i = index"
              class="text-center"
            >
          {{ i + 1 + pagination.page * pagination.limit }}
            </td>
          </ng-container>
          <!-- Name Column -->
          <ng-container matColumnDef="name">
            <th
              mat-header-cell
              *matHeaderCellDef
              mat-sort-header
              class="text-center"
            >
              Role Name
            </th>
            <td mat-cell *matCellDef="let role" class="max-w-[220px]">
              <div
                class="block truncate max-w-[220px]"
                [matTooltip]="role.name"
                matTooltipPosition="above"
              >
                {{ role.name || '--' }}
              </div>
            </td>
          </ng-container>

          <!-- Description Column -->
          <ng-container matColumnDef="desc">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              Description
            </th>
            <td mat-cell *matCellDef="let role" class="max-w-[280px]">
              <div
                class="block truncate max-w-[280px]"
                [matTooltip]="role.desc"
                matTooltipPosition="above"
              >
                {{ role.desc || '--' }}
              </div>
            </td>
          </ng-container>
          <ng-container matColumnDef="userRoleType">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              User Type
            </th>
            <td mat-cell *matCellDef="let role" class="max-w-[200px]">{{( role.userRoleType | titlecase ) ||  '--'  }}</td>
          </ng-container>

          <ng-container matColumnDef="createdAt">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              Created Date
            </th>
            <td mat-cell *matCellDef="let role">
              {{ role.metadata?.createdAt | date: "dd/MM/yyyy" }}
            </td>
          </ng-container>

          <ng-container matColumnDef="updatedAt">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              Updated Date
            </th>
            <td mat-cell *matCellDef="let role">
              {{ role.metadata?.updatedAt | date: "dd/MM/yyyy" }}
            </td>
          </ng-container>

          <!-- Modular Permission Column -->
          <!-- <ng-container matColumnDef="modularPermission">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Modular Permission </th>
                        <td mat-cell *matCellDef="let role"> {{ role.modularPermission.join(', ') }} </td>
                    </ng-container> -->

          <!-- Functional Permission to Add Column -->
          <!-- <ng-container matColumnDef="functionalPermissionToAdd">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Functional Permission to Add </th>
                        <td mat-cell *matCellDef="let role"> {{ role.functionalPermissionToAdd.join(', ') }} </td>
                    </ng-container> -->

          <!-- Functional Permission to Update Column -->
          <!-- <ng-container matColumnDef="functionalPermissionToUpdate">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Functional Permission to Update </th>
                        <td mat-cell *matCellDef="let role"> {{ role.functionalPermissionToUpdate.join(', ') }} </td>
                    </ng-container> -->

          <!-- Functional Permission to Delete Column -->
          <!-- <ng-container matColumnDef="functionalPermissionToDelete">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Functional Permission to Delete </th>
                        <td mat-cell *matCellDef="let role"> {{ role.functionalPermissionToDelete.join(', ') }} </td>
                    </ng-container> -->

          <!-- Other Functional Permission Column -->
          <!-- <ng-container matColumnDef="otherFunctionalPermission">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Other Functional Permission </th>
                        <td mat-cell *matCellDef="let role"> {{ role.otherFunctionalPermission.join(', ') }} </td>
                    </ng-container> -->

          <!-- Action Column (for Edit/Delete buttons) -->
          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef>Actions</th>
            <td mat-cell *matCellDef="let role">
              <button mat-icon-button color="accent" (click)="viewDetail(role)"
                matTooltip="View" matTooltipPosition="above">
                <mat-icon>remove_red_eye</mat-icon>
              </button>
              <button
                [disabled]="!hasDetailedPerm('Role_Management', 'Edit', 'read')"
                mat-icon-button
                (click)="editRole(role)"
                matTooltip="Edit" matTooltipPosition="above"
              >
                <mat-icon>edit</mat-icon>
              </button>
              <span
                [matTooltip]="role.name === 'Vendor Default' ? 'This is a system-defined default role and cannot be deleted.' : 'Delete'"
                matTooltipPosition="above"
              >
                <button
                  [disabled]="!hasDetailedPerm('Role_Management', 'Delete', 'read') || role.name === 'Vendor Default'"
                  mat-icon-button
                  (click)="deleteRole(role)"
                >
                  <mat-icon class="app-text">delete</mat-icon>
                </button>
              </span>
            </td>
          </ng-container>

          <!-- Table Header and Rows -->
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
          <tr class="mat-row" *matNoDataRow>
            <td class="mat-cell text-center py-10 text-gray-400" [attr.colspan]="displayedColumns.length">
              No roles found. Click 'Create Role' to add one.
            </td>
          </tr>
        </table>
        <!-- Paginator -->
      </div>
      <div class="flex justify-end bg-white mx-5">
        <mat-paginator
          [length]="pagination.length"
          [pageSize]="10"
          [pageIndex]="pagination.page"
          [pageSizeOptions]="[5, 10, 25, 100]"
          class=""
          (page)="onPaginateChange($event)"
        >
        </mat-paginator>
      </div>
    </div>
  </div>
</div>
